export default __webpack_public_path__ + "static/media/sliderimg-healthcare.fd618c9d.jpg";